import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION } from './lending-outbound-package-volume-by-product-list-chart.definition';
import { LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA } from './lending-outbound-package-volume-by-product-list-chart.mock';

export const LendingOutboundPackageVolumeByProductListChart = (props: ListChartProps) => <ListChart {...props} />;

LendingOutboundPackageVolumeByProductListChart.definition = LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION;
LendingOutboundPackageVolumeByProductListChart.mockData = LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA;
